module.exports = __webpack_public_path__ + "img/arabic-w.8ecd24bd.svg";